import { useEffect, useState } from "react";
import Reports from "../components/reports";
import { DMI_HEALTH_MONITORING_REPORT_DATA } from "../constants/data.cnst";
import { TABLE_COLUMNS_CONFIG, type ColumnMeta } from "../constants/table.cnst";
import type { DMI_HEALTH_MONITORING_REPORT } from "../interfaces/dashboard";

export default function DmiHealthMonitoring() {
    const dmiHealthMonitoringReportTableColumns: ColumnMeta[] = TABLE_COLUMNS_CONFIG.DMI_HEALTH_MONITORING_REPORT;

    const [dmiHealthMonitoringReportTableData, setDmiHealthMonitoringReportTableData] = useState<DMI_HEALTH_MONITORING_REPORT[]>([]);

    useEffect(() => {
        setDmiHealthMonitoringReportTableData(DMI_HEALTH_MONITORING_REPORT_DATA)
    }, []);

    return (
        <Reports
        reportType="DMI_HEALTH_MONITORING"
        tableColumns={dmiHealthMonitoringReportTableColumns}
        tableData={dmiHealthMonitoringReportTableData} />
    );
}